import React from 'react';
import cx from 'classnames';
// TODO: Import @material-ui from design-system folder
/* eslint-disable restrict-imports/restrict-imports */
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from 'design-system/styles';
import { Typography } from 'design-system/product';

const NucleusLoadingSpinner = ({
  size,
  text,
  textDelay = 0,
  className,
  percentage,
}: {
  size?: number;
  text?: string;
  textDelay?: number;
  className?: string;
  percentage?: number | null;
}) => {
  const classes = useStyles();

  if (percentage !== null && percentage !== undefined) {
    return (
      <div className={classes.loadingProgress}>
        <CircularProgress
          variant="determinate"
          className={`${classes.progressBackground}`}
          size={size || 120}
          thickness={3}
          value={100}
        />

        <CircularProgress
          variant="determinate"
          className={`${classes.progressCircle}`}
          size={size || 120}
          thickness={3}
          value={percentage}
        />

        <div className={classes.percentText}>
          <Typography variant="caption" color="textSecondary">
            {percentage}%
          </Typography>
        </div>

        {text && (
          <p className={classes.text} style={{ animationDelay: `${textDelay}ms` }}>
            {text}
          </p>
        )}
      </div>
    );
  }

  // Default spinner behavior
  return (
    <div className={cx(classes.container, className)}>
      <div style={{ width: `${size || 32}px`, height: `${size || 32}px`, position: 'relative' }}>
        <CircularProgress
          variant="determinate"
          className={`${classes.spinnerBottom} ${classes.spinner}`}
          size={size || 32}
          thickness={4}
          value={100}
        />
        <CircularProgress
          variant="indeterminate"
          disableShrink
          className={`${classes.spinnerTop} ${classes.spinner}`}
          classes={{
            circle: classes.spinnerCircle,
            colorPrimary: classes.color,
          }}
          size={size || 32}
          thickness={4}
        />
      </div>
      {text && (
        <p className={classes.text} style={{ animationDelay: `${textDelay}ms` }}>
          {text}
        </p>
      )}
    </div>
  );
};

export default NucleusLoadingSpinner;

const useStyles = makeStyles(theme => ({
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    flexDirection: 'column',
  },
  spinner: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  spinnerBottom: {
    color: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
  },
  spinnerTop: {
    color: '#1a90ff',
    animationDuration: '700ms',
  },
  spinnerCircle: {
    strokeLinecap: 'round',
  },
  color: {
    color: theme.colors.primary1,
  },
  text: {
    color: theme.colors.black,
    opacity: 0,
    animation: '$fadeIn 1ms forwards',
  },
  loadingProgress: {
    display: 'flex',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative', // Create positioning context
  },
  progressBackground: {
    color: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
    position: 'absolute',
  },
  progressCircle: {
    color: theme.colors.primary1,
    position: 'absolute',
  },
  percentText: {
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  '@keyframes fadeIn': {
    '0%': {
      opacity: 0,
    },
    '100%': {
      opacity: 1,
    },
  },
}));
